import React, { useEffect, useRef, useState } from 'react'
import './ServicesWidget.scss'
import img from '../assets/images/programming.jpg'
import { Link } from 'react-router-dom'

const servicesData = [
  {
    title: 'Software contractors',
    description:
      'Unlock the potential of your projects with our skilled software contractors. We offer affordable, nearshore specialists who are fluent in a multitude of technologies. Whether it’s a short-term project, team expansion, or bridging skill gaps, we have the resources for you.',
    image: img,
  },
  {
    title: 'Web design and development',
    anchor: 'web-development',
    description:
      'Step into the digital age with our expert web design. We craft websites that are responsive, scalable, and SEO-savvy. We build innovative, multi-page solutions tailored to your brand and budget. Each website we create is a bridge, connecting you to your audience.',
    image: img,
  },
  {
    title: 'Software architecture and design',
    anchor: 'software-development',
    description:
      'Great software starts with strong architecture. We design robust, scalable, and secure systems that are customised to your needs. We oversee high-level planning through to technical execution and create the foundations that support your current and future business needs.',
    image: img,
  },
  // {
  //   title: 'Application Integration',
  //   description:
  //     'We help businesses connect and streamline their systems with seamless application integration services. We can integrate third-party software or create custom interfaces. Our expertise will ensure a smooth data flow and boost efficiency across your platforms.',
  //   image: img,
  // },
  {
    title: 'Cloud solutions',
    description:
      'Unlock the limitless potential of the cloud with our expert development services. We develop and deploy cloud-based solutions that enhance scalability, security, and accessibility. We can migrate existing infrastructure or create new cloud-native applications.',
    image: img,
  },
  {
    title: 'Legacy system modernisation',
    description:
      'We specialise in revolutionising outdated systems and helping businesses migrate to the most efficient and up-to-date technologies. Our processes simultaneously improve performance, security, and usability, whilst reducing long-term maintenance costs.',
    image: img,
  },
  {
    title: 'Mobile application development',
    anchor: 'mobile-applications',
    description:
      'Reach customers on the go with our bespoke mobile applications. We create fast, intuitive, and user-friendly apps that enhance audience engagement. We can also build apps for internal business use. Whether boosting business connectivity or igniting excitement at an event, we have the expertise to make it happen.',
    image: img,
  },
  {
    title: 'E-Commerce solutions',
    anchor: 'ecommerce-solutions',
    description:
      'Looking to sell online? Our e-commerce services help businesses design and build secure and user-friendly online stores. TechTonic’s solutions drive sales and provide an exceptional customer experience. We take care of everything, from setting up the platform to integrating payment systems.',
    image: img,
  },
  {
    title: 'IT support and maintenance',
    anchor: 'it-support',
    description:
      'Our IT support services ensure your systems run smoothly. Our expert team is available to provide proactive monitoring and maintenance. We troubleshoot and update your systems to keep them secure and reliable. We minimise downtime and enhance the user experience.',
    image: img,
  },
  {
    title: 'Consulting and strategy',
    anchor: 'consulting-strategy',
    description:
      'We offer expert consulting services to guide your business towards technological success. Whether you need support developing a strategy or enhancing operational efficiency, our expert team provides actionable insights and strategic solutions. Our strategies drive innovation and enable organisations to align their IT investments with their long-term goals.',
    image: img,
  },
]
const ServicesWidget = ({ bckColorClass = "" }) => {
  const [expandedCard, setExpandedCard] = useState<number | null>(null)
  const isHomepage = location.pathname === '/'
  const displayedServices = isHomepage ? servicesData.slice(0, 6) : servicesData


  useEffect(() => {
    const href = window.location.href.substring(
      window.location.href.lastIndexOf('#') + 1
    )
    const element = document.getElementById(href)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }, [])

  const toggleCard = (index: number) => {
    if (expandedCard === index) {
      const element = document.querySelector(`.service-card.expanded`)
      if (element) {
        element.classList.add("collapsed")
        setTimeout(() => {
          setExpandedCard(null);
        }, 500);
      }
    } else {
      setExpandedCard(index);
    }
  };

  return (
    <div className="container fade-in">
      {isHomepage && (<h2 className="section-title">SERVICES</h2>)}
      <div className="section-heading">
        <h4>EXPLORE OUR SERVICES</h4>
        Our Technology Stack and Platforms
        <div className="section-description">
          We offer a range of services including:
        </div>
      </div>

      <div className="services-grid">
        {displayedServices.map((service, index) => (
          <div
            id={service.anchor}
            className={`service-card ${expandedCard === index ? "expanded" : ""
            }`}
            key={index}
          >
            <div
              className={`service-card-bg ${expandedCard === index ? "blurred" : ""
              }`}
              style={{ backgroundImage: `url(${service.image})` }}
            ></div>
            <div className="service-card-content">
              <h3>{service.title}</h3>

              <div className={`service-description ${expandedCard === index ? 'expanded' : ''}`}>
                <p>{service.description}</p>
              </div>

              <button
                className="button"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleCard(index);
                }}
              >
                {expandedCard === index ? "Close" : "Learn More ➔"}
              </button>
            </div>
          </div>
        ))}
      </div>

      {isHomepage && (
        <a href="/services" className='button section-cta'>Explore All of Our Services ➔</a>
      )}
    </div>
  )
}

export default ServicesWidget
